<template>
  <div>
    <page-header :title="$t('bill.account_cost')">
      <div slot="res-status-tab" style="position: absolute; right: 0; top: 10px;">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <account-list id="BillAccountList" :billShared="billShared" :projectShared="projectShared" />
    </page-body>
  </div>
</template>

<script>
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import AccountList from './components/List'

export default {
  name: 'BillAccount',
  components: {
    AccountList,
    BillConfig,
  },
  mixins: [shareMixin],
  data () {
    return {}
  },
}
</script>
